module.exports = __webpack_public_path__ + "img/login.18695e1a.svg";